import * as React from 'react';

import DesktopContainer from 'containers/desktop/index';

/**
 * Lazy version of this debugging component, so it's not compiled into production code
 */
const HighlightAriaLabels = React.lazy(() =>
	process.env.REACT_APP_E2E === 'true'
		? import('containers/HighlightAriaLabels')
		: (Promise.resolve(() => null) as any)
);

const App: React.FC = () => {
	// this will be false for production builds and will be removed by the compiler by dead code elimination
	const isE2ETests =
		process.env.REACT_APP_E2E === 'true' && process.env.NODE_ENV !== 'production';

	if (isE2ETests)
		return (
			<HighlightAriaLabels>
				<DesktopContainer />
			</HighlightAriaLabels>
		);
	return <DesktopContainer />;
};

export default App;
